import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../BaseUrl";
 



// interface UsersState {
//   entities: []
//   loading: 'idle' | 'pending' | 'succeeded' | 'failed'
// }
 const initialState = {
    loading: false,
    cities: [],
    error: '',
    success: false,
    res: false,
} 

const url = `${BASE_URL}/city/`

const token = localStorage.getItem("token")

const config = {
    headers: {
        Authorization: `Token ${token}`,
        // "content-type": "multipart/form-data",
        // 'Cache-Control': 'no-cache',
        // 'Pragma': 'no-cache',
        // 'Expires': '0',
    }
}


export const fetchCity = createAsyncThunk(
    'fetch/city', async () => {
        return axios
        .get(url, config)
        .then((response) => response.data)
    }
)

 export const createCity = createAsyncThunk(
  "create/city", async (formData) => {
    return axios
    .post(url, formData, config)
    .then((response)=> {
      console.log("🚀 ~ file: CitySlice.js:43 ~ .then ~ response:", response)
      
      return response.data;
    }
      ) 
  }
)
 

export const updateCity = createAsyncThunk(
  "update/city", async (formData) => {
    return axios
    .put(`${url}${formData.textId}`, formData, config)
    .then((response) =>{ 
    response.data.localData = formData.localData;
    console.log("🚀 ~ file: CitySlice.js:59 ~ .then ~ formData:", formData)
    return response.data; 
     } 
  )
  }
)

export const deleteCity = createAsyncThunk(
  "delete/city", async (formData) => {
    return axios
    .delete(`${url}${formData.textId}`, config)
    .then((response) =>{ 
    return formData; 
     })
  }
)

const citySlice = createSlice({
    name: "city",
    initialState,
    reducers: {
    updateState(state, action) {
      state.res = action.payload;
    },
    removeSuccessMessage(state, action) {
      state.success = action.payload;
    },
  },
    extraReducers: (builder) => {
      builder.addCase(fetchCity.pending, (state) => {
        state.loading = true;
        state.success = false;
      });
      
      builder.addCase(fetchCity.fulfilled, (state, action) => {
        state.loading = false;
        state.cities = action.payload;
        state.error = "";
         
      });

      builder.addCase(fetchCity.rejected, (state, action) => {
        state.loading = false;
        // state.cities = [];
        state.error = action.error;
        if(action.error.code === 'ERR_BAD_REQUEST'){  
        
          }
           
      });
       
      builder.addCase(createCity.pending, (state, action) => {
        state.loading = true;
        state.success = false;
      }); 
       
      builder.addCase(createCity.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.cities.push(action.payload);
        state.error = "";
      }); 

      builder.addCase(createCity.rejected, (state, action) => {
      state.loading = false;
      // state.cities = [];
      state.error = action.error;
     
    });

      
    builder.addCase(updateCity.fulfilled, (state, action) => {
      state.loading = false;
      state.cities[action.payload.localData] = action.payload;
      state.error = "";
      console.log(action)
    });
 
    builder.addCase(updateCity.rejected, (state, action) => {
      state.loading = false;
      // state.cities = [];
      state.error = action.error;
 
    });
    
    builder.addCase(deleteCity.fulfilled, (state, action) => {
      state.loading = false;
      state.cities.splice(action.payload.localData, 1);
      state.error = "";
    });
        
    builder.addCase(deleteCity.rejected, (state, action) => {
      state.loading = false;
      // state.cities = [];
      state.error = action.error;
 
    });
    },
  });
  



export const { updateState, removeSuccessMessage } = citySlice.actions;
export default citySlice.reducer